import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './PsMoreMenu.css';

export const PsMoreMenu = (
    {
        options,
    },
) => {
    return (
        <li className="dropdown">
            <button
                className="button-icon"
                data-toggle="dropdown"
            >
                <i className="material-icons">{'more_vert'}</i>
            </button>
            <ul className="dropdown-menu pull-right">
                {
                    options.map((option, index) => {
                        const { label, route, click, openNewWindow } = option;

                        if ( route ) {
                            const moreProps = openNewWindow ? {target: '_blank'} : {};
                            return (
                                <li key={index}>
                                    <Link
                                        to={route}
                                        children={label}
                                        {...moreProps}
                                    />
                                </li>
                            );
                        }

                        return (
                            <li key={index}>
                                <button
                                    className={"option-menu"}
                                    onClick={click}
                                    children={label}
                                />
                            </li>
                        );
                    })
                }
            </ul>
        </li>
    );
};

PsMoreMenu.propTypes = {
    options: PropTypes.array,
};

PsMoreMenu.defaultProps = {
    options: [],
};



// WEBPACK FOOTER //
// ./src/app/shared/components/more-menu/PsMoreMenu.jsx